module.exports = __webpack_public_path__ + "img/zhth-1.3cac7c57.png";